import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import type { AuthenticationFlowPageProps } from '../AuthenticationFlow';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Icon from '@mui/material/Icon';
import { useAuth } from 'src/contexts/AuthContext';
import { useRemoveQueryParams } from 'src/hooks/useRemoveQueryParams';

export type AuthenticationResetPasswordSuccessPageProps =
  AuthenticationFlowPageProps;

export function AuthenticationResetPasswordSuccessPage({
  pageId: pageID,
  onPageComplete,
}: AuthenticationResetPasswordSuccessPageProps) {
  const { user } = useAuth();
  useRemoveQueryParams();

  if (!pageID || !onPageComplete) {
    return null;
  }

  return (
    <Stack spacing={'32px'} my={'64px'} width={'100%'} maxWidth={'420px'}>
      <Stack spacing={'8px'}>
        <Typography
          variant="h4"
          fontWeight="500"
          textTransform={'capitalize'}
          textAlign={'center'}
        >
          Reset Password Successfully
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Icon
            component={CheckCircleRoundedIcon}
            color="secondary"
            sx={{ width: 100, height: 100 }}
          />
        </Box>
        <Typography variant="body1" textAlign={'center'}>
          {!!user ? 'Continue to Blumint!' : 'Please sign in.'}
        </Typography>
      </Stack>
      <Box textAlign={'center'}>
        <Button
          variant="contained"
          fullWidth
          onClick={() => {
            if (!!user) {
              onPageComplete(pageID);
            } else {
              onPageComplete(pageID, 'enter email');
            }
          }}
        >
          {user ? 'Close' : 'Sign In'}
        </Button>
      </Box>
    </Stack>
  );
}
